import * as LocalAuthentication from "expo-local-authentication";
import { BaseToast, ErrorToast } from "react-native-toast-message";
import { urlApi, getApiUrl } from "../Api";
import { Platform } from "react-native";

export const MAP_REGION_INITIAL = {
  latitude: -23.565581939429435,
  longitude: -46.65125936001952,
  latitudeDelta: 0.032,
  longitudeDelta: 0.019,
}; // Initial region map

export const CIRCLE_RADIUS_INITIAL = 3000; //Initial Circle radius of device local marker
export const LONGITUDE_DELTA = 0.001; //Defines zoom of maps
export const LATITUDE_DELTA = 0.019; //Defines zoom of maps
export const mapDeltaUnityDetails = {
  latitudeDelta: 0.032,
  longitudeDelta: 0.019,
};
export const IS_IOS = Platform.OS === "ios";
export const IS_WEB = Platform.OS === "web";

export const getDayofWeek = (dayNumber) => {
  switch (dayNumber) {
    case 0:
      return "Domingo";
    case 1:
      return "Segunda";
    case 2:
      return "Terça";
    case 3:
      return "Quarta";
    case 4:
      return "Quinta";
    case 5:
      return "Sexta";
    case 6:
      return "Sabado";
  }
  return "Não encontrado";
};

export const apiCredentials = {
  usernameAPI: "Softcase",
  password: "49D0F59BD0B6691FD962BE079F5A1F9B713CE23E3981FC10BF8232930499C0FC",
};

export function onAuthenticate(setIsAuthenticate) {
  const auth = LocalAuthentication.authenticateAsync({
    promptMessage: "Autentique-se",
    fallbackLabel: "Coloque a senha",
  });
  auth.then((result) => {
    setIsAuthenticate(result.success);
  });
}

export const urlApp = "https://viamaisparking.com.br/";
export const urlPrivacity = "https://api.portalsoftcase.com.br/Viamais/Politica_Privacidade.html"
export const urlTermsOfUse = getApiUrl("/api/v1/File?fileName=Termos_de_uso.pdf")
export const supportMail = "comercial@viamaisparking.com.br"

// App Store URLs - Update these with actual app store links when available
export const APP_STORE_URL = "https://apps.apple.com/br/app/via-mais/id6744304068"; // Replace with actual iOS App Store URL
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=br.com.parkout.viamais"; // Replace with actual Google Play Store URL

export const contacts = {
  address:
    "Edifício NovAmérica Office Park\nAv. Nações Unidas, 18.801 - Sala 801\n8º andar - Vila Almeida - SP\nCEP: 04795-100",
  tellphone: "1143278706",
  mail: "comercial@viamaisparking.com.br",
  contactUs: "https://api.whatsapp.com/send/?phone=5511940157800&text&type=phone_number&app_absent=0",
  geo: {
    latitude: "-23.653475201949554",
    longitude: "-46.72071294114949",
  },
  whatsapp: "11940157800"
};

export const googleMapsAPIKey = "AIzaSyBlkCWcwO49QJwMx31fRheb7f2vsFGGJlU"

export const toastConfig = {
  /*
      Overwrite 'success' type,
      by modifying the existing `BaseToast` component
    */
  success: (props) => (
    <BaseToast
      {...props}
      style={{ borderLeftColor: "pink" }}
      contentContainerStyle={{ paddingHorizontal: 15 }}
      text1Style={{
        fontSize: 15,
        fontWeight: "400",
      }}
    />
  ),
  /*
      Overwrite 'error' type,
      by modifying the existing `ErrorToast` component
    */
  error: (props) => (
    <ErrorToast
      {...props}
      text1Style={{
        fontSize: 17,
      }}
      text2Style={{
        fontSize: 15,
      }}
    />
  ),
};

export const COLOR_VEHICLES = [
  { name: "BRANCO", hex: "#ffffff" },
  { name: "PRATA", hex: "#c0c0c0" },
  { name: "PRETO", hex: "#000000" },
  { name: "CINZA", hex: "#8f847d" },
  { name: "VERMELHO", hex: "#c4342d" },
  { name: "AZUL", hex: "#0e4bef" }, 
]
